import React, { Component, Fragment } from "react";
import { Badge, Button, InputGroup, InputGroupAddon, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import { reassignMainRole, getMainRoles } from "../../../../../api";
import { withAlert } from "../../../../../components/Alert";
import { DictionarySelect } from "../../../../../components";
import { debounce } from "../../../../../utils";

const styles = {
  container: styles => ({
    ...styles,
    flex: "auto",
    zIndex: 2
  }),
};

const formatRoleLabel = option => (
  <span>
    <Badge>{option.client.name}</Badge>
    <span className="ml-1">{option.name}</span>
  </span>
);

class MainRoleAssignment extends Component {
  state = {
    isEditing: false,
    newValue: null,
    showChangesSummary: false,
    changedRoles: [],
  };

  optionsLoader = debounce((filter, callback) => {
    getMainRoles({
      searchPhrase: filter
    })
      .then(r => r.list)
      .then(callback)
      .catch(this.onError);
  }, 500);

  formatLabel = () => {
    const option = this.props.client.mainRole;

    return option?.name;
  };

  setValue = newValue => {
    this.setState(() => ({ newValue }));
  };

  startEditing = () => {
    const newValue = this.props.client.mainRole;

    this.setState(() => ({ newValue, isEditing: true }));
  };
  
  save = () => {
    reassignMainRole({
      clientId: this.props.client.id,
      mainRole: { id: this.state.newValue?.id },
    })
    .then(this.onSuccess)
    .catch(this.onError);
  };

  onSuccessfulEdit = () => {
    this.setState(() => ({ isEditing: false, showChangesSummary: false, changedRoles: [] }), () => {
      this.props.showAlert("Zmiany zostały zapisane.", "success", this.props.onMainRoleReassigned);
    });
  };

  onSuccess = r => {
    if (r.result === 0) {
      const showChangesSummary = r.changedRoles && r.changedRoles.length > 0;
      this.setState(() => ({
        isEditing: showChangesSummary,
        showChangesSummary,
        changedRoles: r.changedRoles || []
      }), () => {
        if (!showChangesSummary) {
          this.onSuccessfulEdit();
        }
      });
    }
    else {
      this.onError();
    }
  };

  onError = () => {
    this.props.showAlert("Wystąpił błąd.", "danger");
  };

  cancel = () => {
    this.setState(() => ({ isEditing: false }));
  };
  
  onKeyDown = e => {
    if (e.key === "Escape") {
      this.cancel();
    }
    else if (e.key === "Enter") {
      const { newValue } = this.state;
      const label = this.formatLabel();

      if (newValue && newValue.name !== label) {
        this.save();
      }
    }
  };
  
  render() {
    const { newValue, isEditing, showChangesSummary, changedRoles } = this.state;
    const label = this.formatLabel();

    return (
      <div>
        {!isEditing && (
          <div>
            <div className="d-inline-block" style={{ width: "calc(1.125em + 0.5rem)" }}>
              {this.props.editable && (
                <FontAwesomeIcon
                  title="Edytuj"
                  icon="edit"
                  className={classNames("clickable text-primary mr-2")}
                  onClick={this.startEditing} />
              )}
            </div>

            <span>{label || <>&nbsp;</>}</span>
          </div>
        )}

        {isEditing && (
          <Fragment>
            <form>
              <InputGroup size="sm">
                <DictionarySelect
                  key={this.props.client.id}
                  endpoint={this.optionsLoader}
                  onChange={this.setValue}
                  value={newValue}
                  styles={styles}
                  valueField="id"
                  placeholder="Wybierz główną rolę"
                  onKeyDown={this.onKeyDown}
                  formatOptionLabel={formatRoleLabel}
                  autoFocus
                  cache
                />

                <InputGroupAddon addonType="append">
                  <Button size="sm" title="Zapisz" onClick={this.save} disabled={!newValue || newValue.name === label}><FontAwesomeIcon icon="check" /></Button>
                  <Button size="sm" title="Anuluj" onClick={this.cancel}><FontAwesomeIcon icon="times" /></Button>
                </InputGroupAddon>
              </InputGroup>
            </form>

            <Modal isOpen={showChangesSummary} backdrop="static" size="lg" centered>
              <ModalHeader>Usunięte uprawnienia</ModalHeader>
              <ModalBody>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Lp</th>
                      <th>Klient</th>
                      <th>Rola</th>
                      <th>Uprawnienie</th>
                    </tr>
                  </thead>
                  <tbody>
                    {changedRoles.map((x, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{x.client.name}</td>
                        <td>{x.role.name}</td>
                        <td>{x.permission.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.onSuccessfulEdit}>Ok</Button>
              </ModalFooter>
            </Modal>
          </Fragment>
        )}
      </div>
    );
  }
}

export default withAlert(MainRoleAssignment);
